import { animate, state, style, transition, trigger } from '@angular/animations';

export const animateText = trigger('animateText', [
    state(
        'hide',
        style({
            opacity: 0,
            maxWidth: '0px',
            overflow: 'hidden',
            lineHeight: '0',
        })
    ),
    state(
        'show',
        style({
            opacity: 1,
            maxWidth: '1000px',
            overflow: 'hidden',
        })
    ),
    transition('hide => show', animate('150ms 300ms ease-out')),
    transition('show => hide', animate('0ms')),
]);
